import axios from "axios";
import { plainToInstance } from "class-transformer";
import { BatchDetailDto, GlobalAdminPatientDetailsDto, GlobalAdminRetrievalSummaryDto, PatientSearchResultDto, PatientsWithVectorizationErrorsDto, RetryFailedChunksResultDto, VectorizationMigrationResultDto, } from "healthex-common/global-admin-retrieval.dtos";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class GlobalAdminRetrievalService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getPatientDetails(patientId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/details", { patientId }), await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(GlobalAdminPatientDetailsDto, response.data);
    }
    async getBatchDetails(patientId, batchId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/batches/:batchId/details", { patientId, batchId }), await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(BatchDetailDto, response.data);
    }
    async migratePatient(patientId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/migrate", { patientId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(VectorizationMigrationResultDto, response.data);
    }
    async getMigrationSummary() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/migration/summary"), await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(GlobalAdminRetrievalSummaryDto, response.data);
    }
    async searchPatients(query) {
        const params = new URLSearchParams();
        if (query.firstName)
            params.append("firstName", query.firstName);
        if (query.lastName)
            params.append("lastName", query.lastName);
        if (query.email)
            params.append("email", query.email);
        const response = await axios.get(`${this.environment.API_BASE_URL}/admin/patients/search?${params.toString()}`, await authenticatedApiConfig(this.authenticationProvider));
        return Array.isArray(response.data) ? response.data.map((item) => plainToInstance(PatientSearchResultDto, item)) : [];
    }
    async listPatientsWithVectorizationErrors(limit = 100, sinceHours = 24 * 7) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/admin/migration/patients-with-vectorization-errors?limit=${limit}&sinceHours=${sinceHours}`, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(PatientsWithVectorizationErrorsDto, response.data);
    }
    async retryFailedEmbeddingChunks(patientId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/patients/:patientId/retry-failed-chunks", { patientId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return plainToInstance(RetryFailedChunksResultDto, response.data);
    }
}
